const redirects = {
    '/3catinfo/eleccions-barca/': '/esport3/eleccions-barca/tema/eleccionsfcb/'
};

const normalizePath = (url) => {
    if (!url) return '/';
    return url.endsWith('/') ? url : url + '/';
};

const extractPath = (url) => {
    try {
        const u = new URL(url);
        return u.pathname;
    } catch {
        return url;
    }
};

const getRedirect = (url, redirect = false) => {
    if (!redirect) return url;

    const path = normalizePath(extractPath(url));

    if (redirects[path]) {
        return normalizePath(redirects[path]);
    }
    /*
    // Deixem preparar per si es vol activar en algun moment.
    // Ex: getRedirect('3catinfo/eleccions-generals-2023-23j/resultats/') > /3catinfo/eleccions/eleccions-generals-23j-2023/resultats/';
    for (const from in redirects) {
        if (path.startsWith(from)) {
            return normalizePath(path.replace(from, redirects[from]));
        }
    }
    */
    return url;
};

export { getRedirect };
